class AdvancePaymentofMarkedOrders {
    constructor(fecha) {
        this.fecha = fecha;
    }
}

export default AdvancePaymentofMarkedOrders;